export default __webpack_public_path__ + "static/transform_meta-9fed145c4d2b24f04e69e01f1fca0aa5.webp";